const ROUTES = {
    LOGIN: process.env.PUBLIC_URL + '/',
    HOME: process.env.PUBLIC_URL + '/home',
    COLLECTIONS: process.env.PUBLIC_URL + '/list/:category',
    COLLECTIONSEMPTY: process.env.PUBLIC_URL + '/list/',
    DETAILS: process.env.PUBLIC_URL + '/details/:article',
    DETAILSEMPTY: process.env.PUBLIC_URL + '/details/',
    SEARCHRESULTS: process.env.PUBLIC_URL + '/results'
  }
  
  export default ROUTES;